import { plainToClass } from 'class-transformer';
import {
  API_CLIENT_INFO_THERAPY_TITLE_CREATE,
  API_CLIENT_INFO_THERAPY_TITLE_DELETE,
  API_CLIENT_INFO_THERAPY_TITLE_FIND_ALL,
  API_CLIENT_INFO_THERAPY_TITLE_FIND_ONE,
  API_CLIENT_INFO_THERAPY_TITLE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { ClientInfoTherapyTitleDto } from '../dto';
import { FindAllResponse } from '../types';

export class ClientInfoTherapyTitleApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<ClientInfoTherapyTitleDto>> {
    return this.httpClient
      .get(API_CLIENT_INFO_THERAPY_TITLE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(ClientInfoTherapyTitleDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<ClientInfoTherapyTitleDto> {
    return this.httpClient
      .get(API_CLIENT_INFO_THERAPY_TITLE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(ClientInfoTherapyTitleDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<ClientInfoTherapyTitleDto> {
    return this.httpClient
      .post(API_CLIENT_INFO_THERAPY_TITLE_CREATE, data)
      .then(({ data }) => {
        return plainToClass(ClientInfoTherapyTitleDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<ClientInfoTherapyTitleDto> {
    return this.httpClient
      .put(API_CLIENT_INFO_THERAPY_TITLE_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(ClientInfoTherapyTitleDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_CLIENT_INFO_THERAPY_TITLE_DELETE, {
      pathParams: { uuid }
    });
  }
}
